import { cn } from '@/lib/cn';

/** Application logo mark (document with tick, blue on yellow). Same artwork as public/logo.svg and the favicon. */
export function AppLogo({ className, title = 'TCMS logo' }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={cn('size-8 shrink-0', className)} role="img" aria-label={title}>
      <rect width="64" height="64" rx="14" fill="#ffe000" />
      <path d="M20 12h17l9 9v29a3 3 0 0 1-3 3H20a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3z" fill="#005a93" />
      <path d="M37 12v9h9" fill="#3399da" />
      <path d="M23.5 36.5l5.5 5.5 11-12" fill="none" stroke="#ffe000" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
